import Header from "../../components/HeaderLaningPage";
import Main from "../../components/MainLaningPage";


const LaningPage = () => {
  return (
    <>
      <Header />
      <Main />
    </>
  );
};

export default LaningPage;
